import { cmsToKmh, cmsToMph } from '@/local/server-data/utils/conversion'

export function getMaxSpeedValue(valueInCms: number, useMetric: boolean) {
  const val = useMetric ? cmsToKmh(valueInCms) : cmsToMph(valueInCms)
  return Math.round(val)
}
